import { motion } from "framer-motion";

const ERPS = [
  { name: "Totvs Protheus", tag: "SPECIALIST", desc: "Especialistas em todo o produto, incluindo o Fluig." },
  { name: "Oracle EBS & Cloud", tag: "ARQUITETURA", desc: "Módulos financeiros, integração e migração para Oracle Cloud." },
  { name: "SAP Business One", tag: "MID-MARKET", desc: "Implementação, ajustes e integrações com ecossistema." },
  { name: "Totvs Logix", tag: "MANUFATURA", desc: "Especialista em todo o produto" },
  { name: "Totvs RM", tag: "BACKOFFICE", desc: "Financeiro, RH e educacional." },
  { name: "Datasul", tag: "EMS", desc: "Módulos industriais, financeiros e apoio à migração." },
];

export default function ERPs() {
  return (
    <section id="erps" className="relative py-28 md:py-36 bg-[#050F26]/40" data-testid="erps-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-8 items-end mb-14">
          <div>
            <p className="label-eyebrow">ERPs & Stacks</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
              Domínio de <span className="gradient-text">6 ERPs</span> de mercado.
            </h2>
          </div>
          <p className="text-lg text-[#B8C0D0] leading-relaxed max-w-xl">
            Diagnóstico, sustentação, projetos, integrações e modernização. Da manufatura ao fiscal — falamos a linguagem do seu ERP.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="erps-grid">
          {ERPS.map((e, i) => (
            <motion.div
              key={e.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="card-surface p-7 relative"
              data-testid={`erp-card-${i}`}
            >
              <div className="flex items-center justify-between mb-4">
                <span className="font-mono-tech text-[10px] text-cyan-400 tracking-[0.28em]">
                  //{e.tag}
                </span>
                <span className="font-mono-tech text-[10px] text-[#8892B0]">0{i + 1}</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-white leading-tight">
                {e.name}
              </h3>
              <p className="mt-4 text-sm text-[#8892B0] leading-relaxed">{e.desc}</p>
              <div className="mt-6 h-px bg-gradient-to-r from-cyan-400/40 via-cyan-400/10 to-transparent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
